import {
  VerticalProductCardWithItem,
  VerticalProductCardWithItemProps,
} from '../components/vertical-product-card-with-item/VerticalProductCardWithItem';
import { createGridContainer } from '../grid-container/Factory';
import { UxGoodsCardItemForVerticalProductCard } from '../vertical-product-card/types';

interface ContainerOtherProps
  extends Pick<VerticalProductCardWithItemProps<UxGoodsCardItemForVerticalProductCard>, 'productNameLineClamp'> {
  onImpression?: (item: UxGoodsCardItemForVerticalProductCard, index: number) => void;
  onClick?: (item: UxGoodsCardItemForVerticalProductCard, index: number, event: React.MouseEvent<HTMLElement>) => void;
  onLikeClick?: (isLiked: boolean, item: UxGoodsCardItemForVerticalProductCard, index: number) => void;
}

export const VerticalProductCardGridContainer = createGridContainer<
  ContainerOtherProps,
  UxGoodsCardItemForVerticalProductCard
>({
  renderProductCard: (item, itemIndex, context) => {
    const { size, columnStyle, otherProps } = context;

    const { productNameLineClamp, onImpression, onClick, onLikeClick } = otherProps;

    return (
      <VerticalProductCardWithItem
        size={size}
        productNameLineClamp={productNameLineClamp}
        metadataPadding={columnStyle === 'basic'}
        item={item}
        onImpression={(item) => onImpression?.(item, itemIndex)}
        onClick={(item, event) => onClick?.(item, itemIndex, event)}
        onLikeClick={(isLiked, item) => onLikeClick?.(isLiked, item, itemIndex)}
      />
    );
  },
});

VerticalProductCardGridContainer.displayName = 'VerticalProductCardGridContainer';

export type VerticalProductCardGridContainerProps = React.ComponentProps<typeof VerticalProductCardGridContainer>;
